import React from "react";
import { IconProps } from "./IconProps";

const FacebookLogoIcon: React.FC<IconProps> = ({
  size,
  thickness,
  ariaLabel,
  color = "currentColor",
}) => {
  switch (`${size}${thickness}`) {
    case "20Light":
      return (
        <svg
          aria-label={ariaLabel}
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10 2C8.41775 2 6.87103 2.46919 5.55544 3.34824C4.23985 4.22729 3.21447 5.47672 2.60897 6.93853C2.00347 8.40034 1.84504 10.0089 2.15372 11.5607C2.4624 13.1126 3.22433 14.538 4.34315 15.6569C5.46197 16.7757 6.88743 17.5376 8.43928 17.8463C9.99113 18.155 11.5997 17.9965 13.0615 17.391C14.5233 16.7855 15.7727 15.7602 16.6518 14.4446C17.5308 13.129 18 11.5822 18 10C17.9978 7.87895 17.1542 5.84542 15.6544 4.34562C14.1546 2.84581 12.121 2.00224 10 2ZM10.6154 16.7408V11.8462H12.4615C12.6247 11.8462 12.7813 11.7813 12.8967 11.6659C13.0121 11.5505 13.0769 11.394 13.0769 11.2308C13.0769 11.0676 13.0121 10.911 12.8967 10.7956C12.7813 10.6802 12.6247 10.6154 12.4615 10.6154H10.6154V8.76923C10.6154 8.44281 10.7451 8.12976 10.9759 7.89894C11.2067 7.66813 11.5197 7.53846 11.8462 7.53846H13.0769C13.2401 7.53846 13.3967 7.47363 13.5121 7.35822C13.6275 7.24281 13.6923 7.08629 13.6923 6.92308C13.6923 6.75987 13.6275 6.60334 13.5121 6.48793C13.3967 6.37253 13.2401 6.30769 13.0769 6.30769H11.8462C11.1933 6.30769 10.5672 6.56703 10.1056 7.02866C9.64396 7.49029 9.38462 8.11639 9.38462 8.76923V10.6154H7.53846C7.37525 10.6154 7.21873 10.6802 7.10332 10.7956C6.98791 10.911 6.92308 11.0676 6.92308 11.2308C6.92308 11.394 6.98791 11.5505 7.10332 11.6659C7.21873 11.7813 7.37525 11.8462 7.53846 11.8462H9.38462V16.7408C7.64984 16.5824 6.0429 15.7614 4.89803 14.4484C3.75317 13.1355 3.15852 11.4317 3.23778 9.69156C3.31705 7.95137 4.06412 6.30873 5.3236 5.10531C6.58308 3.90189 8.25802 3.23034 10 3.23034C11.742 3.23034 13.4169 3.90189 14.6764 5.10531C15.9359 6.30873 16.683 7.95137 16.7622 9.69156C16.8415 11.4317 16.2468 13.1355 15.102 14.4484C13.9571 15.7614 12.3502 16.5824 10.6154 16.7408Z"
            fill={color}
          />
        </svg>
      );
    case "20Thin":
      return (
        <svg
          aria-label={ariaLabel}
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10 2C5.59 2 2 5.59 2 10C2 14.41 5.59 18 10 18C14.41 18 18 14.41 18 10C18 5.59 14.41 2 10 2ZM10.5 16.97V11.75H12.5C12.78 11.75 13 11.53 13 11.25C13 10.97 12.78 10.75 12.5 10.75H10.5V8.75C10.5 8.38 10.64 8.04 10.9 7.78C11.16 7.52 11.51 7.38 11.87 7.38H13.12C13.4 7.38 13.62 7.16 13.62 6.88C13.62 6.6 13.4 6.38 13.12 6.38H11.87C11.25 6.38 10.63 6.63 10.19 7.08C9.74 7.53 9.49 8.12 9.49 8.76V10.76H7.49C7.21 10.76 6.99 10.98 6.99 11.26C6.99 11.54 7.21 11.76 7.49 11.76H9.49V16.98C5.86 16.72 2.99 13.7 2.99 10.01C2.99 6.32 6.14 3 10 3C13.86 3 17 6.14 17 10C17 13.86 14.13 16.72 10.5 16.97Z"
            fill={color}
          />
        </svg>
      );
    case "32Reg":
      return (
        <svg
          aria-label={ariaLabel}
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16 5C9.92487 5 5 9.92487 5 16C5 21.738 9.3935 26.4499 15 26.9552V19H12C11.4477 19 11 18.5523 11 18C11 17.4477 11.4477 17 12 17H15V14C15 12.9391 15.4214 11.9217 16.1716 11.1716C16.9217 10.4214 17.9391 10 19 10H21C21.5523 10 22 10.4477 22 11C22 11.5523 21.5523 12 21 12H19C18.4696 12 17.9609 12.2107 17.5858 12.5858C17.2107 12.9609 17 13.4696 17 14V17H20C20.5523 17 21 17.4477 21 18C21 18.5523 20.5523 19 20 19H17V26.9552C22.6065 26.4499 27 21.738 27 16C27 9.92487 22.0751 5 16 5ZM29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16Z"
            fill={color}
          />
        </svg>
      );
    default:
      return null;
  }
};

export default FacebookLogoIcon;
